var _style, _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupeArbre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "groupe",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 17",
    style: {
      enableBackground: "new 0 0 17 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.stgrpa0{fill:#605F71;}\r\n\t.stgrpa1{fill:none;stroke:#605F71;stroke-width:0.25;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "stgrpa0",
    d: "M15.5,4L15.2,4l-1.3,0.1l-0.4,0.6l-0.3-0.1l-1-0.9l-0.2-0.5l-0.2-0.5l-0.7-0.6L10.4,2l0,0.4l0.8,0.7l0.4,0.4 l-0.4,0.2l-0.3-0.1l-0.5-0.2l0-0.4L9.6,2.7l-0.2,1L8.7,3.8l0.1,0.5l0.9,0.2l0.2-0.9l0.7,0.1L10.9,4h0.5l0.4,0.7l1,1l-0.1,0.4 L11.9,6l-1.4,0.7l-1,1.2L9.4,8.4H9.1L8.4,8.1L7.8,8.4l0.2,0.7l0.3-0.3l0.5,0l0,0.6l0.4,0.1l0.4,0.5l0.7-0.2l0.8,0.1l0.9,0.2 l0.4,0.1L13,11l1.4,0.8l-0.9,1.8l-1,0.5l-0.4,1L10.7,16l-0.2,0.5c3.6-0.9,6.3-4.1,6.3-8C16.8,6.8,16.3,5.3,15.5,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stgrpa0",
    d: "M9.5,12.9l-0.6-1.1l0.6-1.2l-0.6-0.2L8.3,9.8L6.9,9.5l-0.5-1v0.6H6.2L5.1,7.5V6.2L4.2,4.8L2.8,5H1.9L1.4,4.7 L2,4.2L1.4,4.4C0.7,5.6,0.3,7,0.3,8.5c0,4.6,3.7,8.3,8.3,8.3c0.4,0,0.7,0,1-0.1l-0.1-1c0,0,0.4-1.5,0.4-1.5 C9.9,14.1,9.5,12.9,9.5,12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stgrpa0",
    d: "M3.3,2.9l1.5-0.2l0.7-0.4l0.8,0.2l1.2-0.1l0.4-0.7l0.6,0.1L10,1.8l0.4-0.5L11,0.9l0.8,0.1l0.3,0 c-1.1-0.5-2.3-0.8-3.6-0.8c-2.6,0-4.9,1.2-6.5,3h0L3.3,2.9z M8.9,1l0.9-0.5l0.5,0.3L9.6,1.5L8.8,1.6L8.5,1.3L8.9,1z M6.4,1.1 l0.4,0.2l0.5-0.2l0.3,0.5L6.4,1.9L5.9,1.6C5.9,1.6,6.4,1.2,6.4,1.1z"
  }))), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "stgrpa1",
    cx: 8.5,
    cy: 8.5,
    r: 8.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupeArbre);
export default __webpack_public_path__ + "static/media/Groupe-arbre.7e0fd4714162e9f9e8a27011978274de.svg";
export { ForwardRef as ReactComponent };